export default __webpack_public_path__ + "static/media/uploader-medtronic-problem-2.72c30d22.png";